import { render, staticRenderFns } from "./leadForm.vue?vue&type=template&id=f689a8cc"
import script from "./leadForm.vue?vue&type=script&lang=js"
export * from "./leadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports